import { KlegendTheme } from "../.internal/themes/KlegendTheme";
export default KlegendTheme;